// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"4002a77e","453":"82a61875","600":"1767daa0","626":"e0a82177","644":"5856048a","880":"f2a9b78d","883":"9629a2aa"}[chunkId] + ".chunk.js";
};